import { FC, useEffect, useState } from 'react'
import { DefaultGrid } from '../../../../../../components/grids/default/defaultGrid';
import { BaseModalWindow } from '../../../../../../components/modalWindows/BaseModalWindow'
import styles from '../../../../../../components/modalWindows/styles/BaseModalWindow.module.scss'
import { v4 as uuidv4 } from 'uuid';
import useGridFilter from '../../../../../../system/hooks/useGridFilter';
import { useAppContext } from '../../../../../../system/providers/appContextProvider';
import { RoleDataProvider } from '../../../../../../Services/DataProviders/RoleDataProvider';
import { IRoleDTO, IRoleViewDTO } from '../../../../../../libs/coreapi-dto/service/role';
import { UserDataProvider } from '../../../../../../Services/DataProviders/UserDataProvider';
import { RoleLocalDataProvider } from '../../../../../../Services/DataProviders/RoleLocalDataProvider';
import RoleGridMinimalPluginSettings from '../../../../Role/RoleGridMinimalPluginSettings';

export type TypeOpen = 'Create' | 'Edit'

interface IUserLocalRolesModalProps {
    ok: () => void
    cancel: () => void
    userId: string | null
}

export const UserLocalRolesModal: FC<IUserLocalRolesModalProps> = (props) => {
    const appCtx = useAppContext();
    const roleDataProvider = new RoleDataProvider(appCtx.coreApiService);
    const roleLocalDataProvider = new RoleLocalDataProvider(appCtx.coreApiService);
    const userDataProvider = new UserDataProvider(appCtx.coreApiService);
    const [rolesData, setRolesData] = useState<IRoleViewDTO[]>([]);
    const [roleGridFilter, dispatchRoleGridFilter] = useGridFilter();
    const [roleSelectedItem, setRoleSelectedItem] = useState<IGridRow>();
    const [roleSelected, setRoleSelected] = useState<IRoleViewDTO | null>(null);

    useEffect(() => {
        loadRoles(()=>{});
    }, [])

    useEffect(() => {
        if (roleSelectedItem) {
            roleDataProvider.getRoleById(roleSelectedItem.idGlobal, (e: IRoleDTO) => {
                setRoleSelected({ 
                    idGlobal: e.id, 
                    name: e.name,
                    dateCreated: e.dateCreated,
                    dateModified: e.dateModified,
                    dateDeleted: e.dateDeleted 
                })
            })
        }
    }, [roleSelectedItem])

    const refresh = () => {
        setRoleSelectedItem(undefined);
        setRoleSelected(null);
    }

    const loadRoles = (callback: () => void) => {
        roleLocalDataProvider.getAllRoles((e) => {
            let roles: IRoleViewDTO[] = [];
            e.forEach(x => {
                if (x.normalizedName !== 'SUPERUSER' && !x.dateDeleted)
                    roles.push({
                        idGlobal:
                            x.idGlobal,
                        name: x.name,
                        dateCreated: x.dateCreated,
                        dateModified: x.dateModified,
                        dateDeleted: x.dateDeleted
                    });
            });
            setRolesData(roles);
            callback();
        })
    }

    const syncAddRole = (role, callback: () => void)=> {
        if (props.userId)
            roleLocalDataProvider.addRoleForUser(role.idGlobal as string, props.userId, ()=> {
                callback();
            })

    }

    const addRole = () => {
        if (props.userId && roleSelected) {
            userDataProvider.addRole(props.userId, roleSelected.name, () => {
                //#88381 Ввиду новой синхронизации реббита убираем старую синхру.
                props.ok()
                refresh()
            })
        }
    }
    return (
        <BaseModalWindow
            header='Добавление ролей'
            ok={{
                onClick: () => {
                    addRole()
                },
                title: "Добавить роль"
            }}
            cancel={{ onClick: () => props.cancel(), title: "Закрыть" }}
            modalWindowClassName={styles.flexModalWindow}
            footerStyle='customStyles'
        >
            {
                <div className={styles.gridWrapper}>
                    <div className={styles.masterGrid}>
                        <>
                            <span>Выбрать роль:</span>
                            <DefaultGrid
                                gridId={uuidv4()}
                                data={rolesData}
                                totalCount={0}
                                filter={roleGridFilter}
                                plugin={RoleGridMinimalPluginSettings}
                                hiddenPagination={{ hiddenCountRow: true, hiddenNumberPage: true }}
                                selectedItem={roleSelectedItem}
                                onSelect={(row) => {
                                    setRoleSelectedItem(row)
                                }}
                                onSort={(i) => dispatchRoleGridFilter({ type: "sort", payload: i.propertyName })}
                                onFilterDelete={(i) => dispatchRoleGridFilter({ type: "deleteColumnFilter", payload: i.propertyName })}
                                onPageNumberChange={(n) => dispatchRoleGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
                                onNumberPerPageChange={(n) => dispatchRoleGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
                            />
                        </>
                    </div>
                </div>
            }
        </BaseModalWindow>
    )
}